export default __webpack_public_path__ + "static/media/WardIcon.d81a05e7.svg";